import { Typography, Button, IconBackCircle } from '@up-riac/bespoke-ui';
import React from 'react';
export const HeaderMobileMenuHeader = ({
  children, id, onBack, to, onPress,
}: React.PropsWithChildren<{
  id: string, onBack: () => void,
  to?: string,
  onPress?: () => void,
}>): JSX.Element => {
  const typography = <Typography
    weight='extrabold' heading size='sm' className='grow-1 h-[22px]' align='center'
  >
    {children}
  </Typography>;
  return (
    <div
      className='h-12 pl-[11px] pr-[7px] py-2 bg-accent text-surface-dark flex flex-row items-center gap-1 mb-3'
      id={id}
    >
      <Button
        unstyled className='rounded-full focus:rounded-full size-10 shrink-0 flex items-center justify-center' onPress={onBack}
      >
        <IconBackCircle className='size-8 shrink-0' />
      </Button>
      {(to || onPress)
        ? <Button unstyled className='flex flex-row items-center w-full hover:underline decoration-2  ' to={to} onPress={onPress}>{typography}</Button>
        : typography
      }
      <div className='size-10 shrink-0' />
    </div>
  );
};
